import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Icon } from '../../../../../../../Icon/Icon';
import { useClearUpponOptionsClosing, useIsHidden, useOnMouseDown } from './hooks';
import { useClassName } from '../../../../../../../../hooks';
import './RemoveButton.scss';
export const RemoveButton = ({ option, removable, onDelete, setValue, hovered, setHovered, selectedValues, optionsAreOpen, }) => {
    const onMouseDown = useOnMouseDown({ option, onDelete, setValue });
    const color = useMemo(() => (hovered ? 'danger-500' : 'black'), [hovered]);
    const className = useClassName({ name: 'auto-complete-option-remove-button', prefixed: true });
    const hidden = useIsHidden({ option, removable, selectedValues });
    useClearUpponOptionsClosing({ optionsAreOpen, setHovered });
    if (hidden)
        return null;
    return (_jsx("div", { "data-testid": `auto-complete-remove-option-${option?.value}`, onMouseOver: () => setHovered(true), onMouseOut: () => setHovered(false), className: className, onMouseDown: onMouseDown, children: _jsx(Icon, { name: 'ban', size: 'md', color: color }) }));
};
